export default __webpack_public_path__ + "static/media/mini-human-body-back.d0b77db0.png";